/**
 * MN buy buttons — inject brand arrow into ATC + Buy now.
 * Also keeps sample PDP price in sync with quantity (unit × qty).
 * Buy it now stays hidden until Shopify hydrates the button (no refresh flicker).
 */
(function () {
  var ARROW_HTML =
    '<span class="button__arrow svg-wrapper" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/>' +
    '</svg></span>';

  var PAYMENT_READY_CLASS = 'mn-payment-button--ready';
  var revealScheduled = false;
  var failsafeTimer = null;

  function isPaymentButton(btn) {
    if (!(btn instanceof Element)) return false;
    return (
      btn.classList.contains('shopify-payment-button__button') ||
      btn.classList.contains('shopify-payment-button__button--unbranded') ||
      Boolean(btn.closest('.shopify-payment-button'))
    );
  }

  function ensureArrow(btn) {
    if (!(btn instanceof Element) || btn.disabled) return;
    if (btn.querySelector('.button__arrow')) return;
    btn.insertAdjacentHTML('beforeend', ARROW_HTML);
  }

  function revealPaymentHost(host) {
    if (!(host instanceof Element)) return;
    var btn =
      host.querySelector(
        '.shopify-payment-button__button, .shopify-payment-button__button--unbranded, button, [role="button"]'
      ) || null;
    if (!btn) return;
    ensureArrow(btn);
    host.classList.add(PAYMENT_READY_CLASS);
  }

  function syncPaymentButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('.shopify-payment-button').forEach(revealPaymentHost);
  }

  function inject(root) {
    var scope = root || document;
    scope
      .querySelectorAll(
        '.product-form__submit.button:not([disabled]), .shopify-payment-button__button, .shopify-payment-button__button--unbranded'
      )
      .forEach(function (btn) {
        ensureArrow(btn);
        if (isPaymentButton(btn)) {
          var host = btn.closest('.shopify-payment-button');
          if (host) host.classList.add(PAYMENT_READY_CLASS);
        }
      });
    syncPaymentButtons(scope);
  }

  function scheduleInject(root) {
    if (revealScheduled) return;
    revealScheduled = true;
    requestAnimationFrame(function () {
      revealScheduled = false;
      inject(root || document);
    });
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var code =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function getPrimaryPriceNode(priceRoot) {
    if (!priceRoot) return null;
    var priceEl = priceRoot.classList.contains('price')
      ? priceRoot
      : priceRoot.querySelector('.price') || priceRoot;
    if (priceEl.classList.contains('price--on-sale')) {
      return (
        priceRoot.querySelector('.price__sale .price-item--sale:not(s)') ||
        priceRoot.querySelector('.price-item--sale:not(s)')
      );
    }
    return (
      priceRoot.querySelector('.price__regular .price-item--regular:not(s)') ||
      priceRoot.querySelector('.price-item--regular:not(s)')
    );
  }

  function syncSamplePrice(priceRoot) {
    if (!priceRoot || priceRoot.getAttribute('data-mn-sample-price') !== 'true') return;
    // Custom options owns price when present
    if (document.querySelector('mn-product-custom-options[data-sample-purchase="true"]')) return;

    var unitCents = parseInt(priceRoot.getAttribute('data-mn-sample-price-cents'), 10) || 0;
    if (unitCents <= 0) return;

    var sectionId = (priceRoot.id || '').replace(/^price-/, '');
    var productInfo = priceRoot.closest('product-info');
    var qtyInput =
      (productInfo && productInfo.querySelector('input.quantity__input[name="quantity"]')) ||
      document.getElementById('Quantity-' + sectionId);
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var target = getPrimaryPriceNode(priceRoot);
    if (!target) return;
    target.textContent = formatMoney(unitCents * qty);
  }

  function syncAllSamplePrices(root) {
    (root || document)
      .querySelectorAll('[id^="price-"][data-mn-sample-price="true"]')
      .forEach(syncSamplePrice);
  }

  function bindSampleQty() {
    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.classList.contains('quantity__input') && input.name !== 'quantity') return;
        syncAllSamplePrices(document);
      },
      true
    );
    document.addEventListener(
      'input',
      function (event) {
        var input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.classList.contains('quantity__input') && input.name !== 'quantity') return;
        syncAllSamplePrices(document);
      },
      true
    );
  }

  function startFailsafeReveal() {
    if (failsafeTimer) return;
    failsafeTimer = window.setTimeout(function () {
      document.querySelectorAll('.shopify-payment-button:not(.' + PAYMENT_READY_CLASS + ')').forEach(function (host) {
        host.classList.add(PAYMENT_READY_CLASS);
      });
    }, 2500);
  }

  function observe() {
    inject(document);
    syncAllSamplePrices(document);
    bindSampleQty();
    startFailsafeReveal();

    var hosts = document.querySelectorAll(
      '.product-form__buttons, .mn-product-cta, .product-form, product-form, product-info'
    );
    if (!hosts.length || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      scheduleInject(document);
      syncAllSamplePrices(document);
    });
    hosts.forEach(function (host) {
      observer.observe(host, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
